import '@helix-ds/tokens/css'
import '@helix-ds/react/styles.css'
import '@/styles/globals.css'
import '@/styles/typography.css'
import 'flowbite'
import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { initializeSentry } from './sentry.config'

// Initialize Sentry as early as possible
initializeSentry()

// Dark mode is temporarily disabled until rendering issues are fixed.
document.documentElement.classList.remove('dark')
document.documentElement.style.colorScheme = 'light'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Sentry.ErrorBoundary
        fallback={({ error, resetError }) => (
          <div className="flex min-h-screen items-center justify-center bg-background-gray px-4">
            <div className="w-full max-w-md rounded-base border border-border-base bg-background-primary p-8 text-center shadow-xl dark:border-gray-700">
              <h1 className="mb-4 text-2xl font-bold text-error-600">Something went wrong</h1>
              <p className="mb-4 text-text-body">
                {error instanceof Error ? error.message : 'Please refresh the page to try again.'}
              </p>
              <div className="flex flex-wrap justify-center gap-3">
                <button
                  type="button"
                  onClick={resetError}
                  className="rounded-full bg-brand-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-700 focus:outline-none focus:ring-4 focus:ring-brand-600/20"
                >
                  Try again
                </button>
                <button
                  type="button"
                  onClick={() => window.location.reload()}
                  className="rounded-full border border-border-base bg-background-secondary-medium px-4 py-2 text-sm font-medium text-text-body transition-colors hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-100 dark:border-gray-600 dark:hover:bg-gray-800"
                >
                  Refresh page
                </button>
              </div>
            </div>
          </div>
        )}
        showDialog
      >
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
)
